function bindMouseOverToMegaMenu (item) {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("summary").addEventListener("mouseover", () => {
          item.setAttribute("open", true);
        });
        item.querySelector("summary").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
}

let items = document.querySelector(".custom-desktop-menu").querySelectorAll("details");
items.forEach(bindMouseOverToMegaMenu);


$(".flmenu > summary").mouseover(function(){
    setTimeout(() => {
        $(".slmenu").removeAttr("open");
        $(this).parent().find('ul li:first-child details').attr("open", true);
        /*
        let height = $(this).parent().find('ul details[open] ul').height();
        height = height + 50;
        $(this).parent().find('> ul').css("min-height", height)
        */
    }, 10);
});